// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background {
  min-height: 450px;
  background-color: var(--main-gray-background, #f0f0f0);
  width: 100%;
  padding: 15px;
  padding-bottom: 3.5rem;
}

.heading {
  padding: 3rem 50px 0.5rem 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.line {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 150px;
  background-color: #d9d9d9;
  border: 2px solid #cccccc;
}

.learn-more-header {
  font-family: "Roboto-Slab";
  font-size: 34px;
  color: #12394d;
  font-weight: 700;
  margin: 0;
}

.text-col {
  padding: 25px;
  display: flex;
  align-items: center;
}

.img-col {
  padding: 15px;
  max-height: 400px;
  overflow: hidden;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}

.iframe-container {
  position: relative;
  width: 100%;
}

iframe {
  text-align: center;
  width: 60%;
  height: 60%;
  aspect-ratio: 16 / 9;
}

.paragraph {
  font-family: "Roboto";
  font-size: 18px;
  text-align: justify;
  text-justify: inter-word;

}

.learn-more-shell {
  background: #ffffff;
  margin: 0 auto;
  max-width: 1120px;
  padding: 42px 44px 54px;
}

.learn-more-back-button {
  align-items: center;
  background: #cc0000;
  border: 0;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 700;
  gap: 8px;
  min-height: 40px;
  padding: 0 16px;
}

.learn-more-titlebar {
  margin: 26px 0 34px;
  text-align: center;
}

.faq-list {
  display: grid;
  gap: 24px;
  margin: 0 auto;
  max-width: 860px;
}

.faq-item {
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 24px;
}

.faq-item h2 {
  color: #12394d;
  font-family: "Roboto-Slab", "Roboto Slab", serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.25;
  margin: 0 0 10px;
}

.back-button-div {
  display: flex;
  justify-content: right;
  /* margin: 0; */
  padding: 0;
  margin-left: auto;
}

@media (max-width: 1000px) {
  .about-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .img-col {
    width: 500px;
    height: 100%
  }

  .paragraph {
    font-size: 20px;
  }

  iframe {
    text-align: center;
    width: 100%;
    height: 100%;
    aspect-ratio: 16 / 9;
  }

  .last-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .child1 {
    order: 2;
  }

  .child2 {
    padding-right: 0px;
    order: 1;
  }

  .img-col {
    height: 1000px;
  }
}

@media (max-width: 700px) {
  .back-button-div {
    margin-right: 0;
    margin-left: 10px;
  }

  .container {
    padding: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles-arabic/learn-more.rtl.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,sDAAsD;EACtD,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,wBAAwB;;AAE1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".background {\n  min-height: 450px;\n  background-color: var(--main-gray-background, #f0f0f0);\n  width: 100%;\n  padding: 15px;\n  padding-bottom: 3.5rem;\n}\n\n.heading {\n  padding: 3rem 50px 0.5rem 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.line {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  width: 150px;\n  background-color: #d9d9d9;\n  border: 2px solid #cccccc;\n}\n\n.learn-more-header {\n  font-family: \"Roboto-Slab\";\n  font-size: 34px;\n  color: #12394d;\n  font-weight: 700;\n  margin: 0;\n}\n\n.text-col {\n  padding: 25px;\n  display: flex;\n  align-items: center;\n}\n\n.img-col {\n  padding: 15px;\n  max-height: 400px;\n  overflow: hidden;\n}\n\n.image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n}\n\n.iframe-container {\n  position: relative;\n  width: 100%;\n}\n\niframe {\n  text-align: center;\n  width: 60%;\n  height: 60%;\n  aspect-ratio: 16 / 9;\n}\n\n.paragraph {\n  font-family: \"Roboto\";\n  font-size: 18px;\n  text-align: justify;\n  text-justify: inter-word;\n\n}\n\n.learn-more-shell {\n  background: #ffffff;\n  margin: 0 auto;\n  max-width: 1120px;\n  padding: 42px 44px 54px;\n}\n\n.learn-more-back-button {\n  align-items: center;\n  background: #cc0000;\n  border: 0;\n  color: #ffffff;\n  cursor: pointer;\n  display: inline-flex;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  gap: 8px;\n  min-height: 40px;\n  padding: 0 16px;\n}\n\n.learn-more-titlebar {\n  margin: 26px 0 34px;\n  text-align: center;\n}\n\n.faq-list {\n  display: grid;\n  gap: 24px;\n  margin: 0 auto;\n  max-width: 860px;\n}\n\n.faq-item {\n  border-bottom: 1px solid #e4e4e4;\n  padding-bottom: 24px;\n}\n\n.faq-item h2 {\n  color: #12394d;\n  font-family: \"Roboto-Slab\", \"Roboto Slab\", serif;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.25;\n  margin: 0 0 10px;\n}\n\n.back-button-div {\n  display: flex;\n  justify-content: right;\n  /* margin: 0; */\n  padding: 0;\n  margin-left: auto;\n}\n\n@media (max-width: 1000px) {\n  .about-section {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .img-col {\n    width: 500px;\n    height: 100%\n  }\n\n  .paragraph {\n    font-size: 20px;\n  }\n\n  iframe {\n    text-align: center;\n    width: 100%;\n    height: 100%;\n    aspect-ratio: 16 / 9;\n  }\n\n  .last-section {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .child1 {\n    order: 2;\n  }\n\n  .child2 {\n    padding-right: 0px;\n    order: 1;\n  }\n\n  .img-col {\n    height: 1000px;\n  }\n}\n\n@media (max-width: 700px) {\n  .back-button-div {\n    margin-right: 0;\n    margin-left: 10px;\n  }\n\n  .container {\n    padding: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
